/* QILATES — Find your star: drag / slider / "Show me" positions the figure; when the base of the
   skull (Fengchi, GB20) sits on the first pair of stars the section switches to its "found" state.
   Position is in mat units (0–470, top of mat = 0); the first stars are at data-target. */
(function () {
  function setup(root) {
    if (root.dataset.fsReady) return;
    root.dataset.fsReady = '1';

    var TARGET = +root.dataset.target || 234, TOL = 7;
    var copy = {};
    try { copy = JSON.parse(root.querySelector('[data-fs-copy]').innerHTML); } catch (e) {}
    var range = root.querySelector('[data-fs-range]');
    var track = root.querySelector('[data-fs-track]');
    var lo = +range.min, hi = +range.max, wasOk = false, demo = false, burstT;
    if (track) track.style.setProperty('--t', (TARGET - lo) / (hi - lo));
    var badge = root.querySelector('[data-fs-badge]');
    var msg = root.querySelector('[data-fs-msg]');
    var side = root.querySelector('[data-fs-side]');
    var sideGB = root.querySelector('[data-fs-side-gb]');
    var drag = root.querySelector('[data-fs-drag]');
    var box = root.querySelector('.fs-topbox');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // side view: mat depth (y, mat units) maps to x
    var sx = function (y) { return 260 + (y - TARGET) * 1.45; };
    var stars = '', grooves = '';
    [0, 40.8, 81.6, 122.4, 163.2].forEach(function (d) {
      var x = sx(TARGET + d);
      stars += '<path d="M' + (x - 10) + ' 200 L' + x + ' 189 L' + (x + 10) + ' 200 Z"/>';
    });
    for (var i = 0; i < 9; i++) { var gx = sx(60) + i * 14; grooves += '<path d="M' + gx + ' 203 q4 -3 8 0 t8 0"/>'; }
    root.querySelector('[data-fs-stars]').innerHTML = stars;
    root.querySelector('[data-fs-grooves]').innerHTML = grooves;
    root.querySelector('[data-fs-swirl-label]').setAttribute('x', sx(70));

    function set(y) {
      y = Math.max(+range.min, Math.min(+range.max, y));
      range.value = Math.round(y);
      root.style.setProperty('--fs-y', y);
      var t = 'translate(' + sx(y) + ',0)';
      side.setAttribute('transform', t);
      sideGB.setAttribute('transform', t);
      var d = y - TARGET, ok = Math.abs(d) <= TOL;
      root.classList.toggle('is-ok', ok);
      if (track) {
        var p = (y - lo) / (hi - lo), t = (TARGET - lo) / (hi - lo);
        track.style.setProperty('--p', p);
        track.style.setProperty('--a', Math.min(p, t));
        track.style.setProperty('--b', Math.max(p, t));
      }
      if (ok && !wasOk && !demo && !reduce) {   // one-shot sparkle when the star is reached
        root.classList.remove('fs-burst'); void root.offsetWidth; root.classList.add('fs-burst');
        clearTimeout(burstT); burstT = setTimeout(function () { root.classList.remove('fs-burst'); }, 1000);
      }
      wasOk = ok;
      if (ok) { badge.textContent = copy.ok_badge || 'You found your star'; msg.textContent = copy.ok || ''; }
      else if (d < 0) { badge.textContent = 'Too high'; msg.textContent = copy.high || ''; }
      else { badge.textContent = 'Too low'; msg.textContent = copy.low || ''; }
    }
    range.addEventListener('input', function () { set(+range.value); });
    function touched() { if (track) track.classList.add('is-touched'); }
    ['pointerdown', 'keydown', 'focus'].forEach(function (t) { range.addEventListener(t, touched); });

    var dragging = false, startY = 0, startV = 0;
    function matY(e) { var r = box.getBoundingClientRect(); return (e.clientY - r.top) * (470 / r.height); }
    drag.addEventListener('pointerdown', function (e) { touched(); dragging = true; startY = matY(e); startV = +range.value; drag.setPointerCapture(e.pointerId); });
    drag.addEventListener('pointermove', function (e) { if (dragging) set(startV + matY(e) - startY); });
    ['pointerup', 'pointercancel'].forEach(function (t) { drag.addEventListener(t, function () { dragging = false; }); });

    root.querySelector('[data-fs-demo]').addEventListener('click', function () {
      touched();
      if (reduce) { set(TARGET); return; }
      demo = true;
      var keys = [[0, 168], [900, 300], [1900, TARGET]], t0 = performance.now(), from = +range.value;
      (function step(now) {
        var t = now - t0, k = 0;
        while (k < keys.length - 1 && t > keys[k + 1][0]) k++;
        if (k >= keys.length - 1) { demo = false; wasOk = false; set(TARGET); return; }
        var a = keys[k], b = keys[k + 1], p = Math.min(1, (t - a[0]) / (b[0] - a[0]));
        var e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2, y0 = k === 0 ? from : a[1];
        set(y0 + (b[1] - y0) * e);
        requestAnimationFrame(step);
      })(t0);
    });

    set(+root.dataset.start || +range.value);
  }

  function init() { document.querySelectorAll('[data-find-star]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
